// Mirrors the server-side PASSWORD_REGEXP in config/initializers/constants.rb.
// Keep both in sync: 8-64 chars, at least one upper/lower/digit, no spaces,
// and only these special characters: ! @ $ % ^ & * ( ) + _ - #
export const PASSWORD_RULES = {
  length: (password) => password.length >= 8 && password.length <= 64,
  uppercase: (password) => /[A-Z]/.test(password),
  lowercase: (password) => /[a-z]/.test(password),
  number: (password) => /\d/.test(password),
  charset: (password) => /^[0-9a-zA-Z!@$%^&*()+_\-#]*$/.test(password)
}
